export const useLicenseService = () => {

    return{   
        status : data => {
          let myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          
          let requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
          };

          return fetch("api/License/CheckMVLicenseServerIsOnline", requestOptions);
        },     
        customerInfo : data => {
          let myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          
          let requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
          };

          return fetch("api/License/GetCustomerInfo", requestOptions);
        },     
        validate : data => {
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            let raw = JSON.stringify(data);
            
            let requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              redirect: 'follow'
            };
            
            return fetch("api/License/ValidateMVLicense", requestOptions);
        },

        release : data => {
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            let raw = JSON.stringify(data);
            
            let requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              redirect: 'follow'
            };
            
            return fetch("api/License/ReleaseMVLicenseServerToken", requestOptions);
        }
    }
}